import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'as-select-column',
  templateUrl: './select-column.component.html',
  styleUrls: ['./select-column.component.scss']
})
export class SelectColumnComponent implements OnInit {

  @Input() item;
  @Input() checked;
  @Output() selectedItem = new EventEmitter();

  constructor() { }

  ngOnInit() {

  }
  handleSelectedItem(event){
    this.selectedItem.emit({item: this.item, selected: event})
  }
}
